module.exports = __webpack_public_path__ + "img/10.7c1dedac.png";